/**
 * THE EXERCISE REGISTRY — registration point.
 *
 * ============================================================================
 *  ADDING AN EXERCISE IS TWO STEPS. THAT IS THE WHOLE ARCHITECTURE (§1).
 *
 *    1. Create one file in ./library/
 *    2. Add one import and one register() line below
 *
 *  Nothing else in the codebase changes. No migration, no form, no chart code,
 *  no safety-monitor change, no builder change. If a new exercise seems to
 *  require touching anything else, stop — the contract in types.ts is missing
 *  something, and extending the contract is the correct fix.
 *
 *  Full walkthrough: docs/ADDING_AN_EXERCISE.md
 * ============================================================================
 */
import { register } from './registry.js';
// --- Oculomotor --------------------------------------------------------------
// (Phase 2: smooth_pursuit lands here first, then saccades proves the
//  acceptance test by changing nothing but these two lines.)
import { smoothPursuit } from './library/smooth-pursuit.js';
register(smoothPursuit);
import { saccades } from './library/saccades.js';
register(saccades);
import { pursuitSaccadeCombo } from './library/pursuit-saccade-combo.js';
register(pursuitSaccadeCombo);
import { antiSaccades } from './library/anti-saccades.js';
register(antiSaccades);
// --- Cognitive ---------------------------------------------------------------
// (Phase 6)
// --- Dual-task ---------------------------------------------------------------
// (architected for, deliberately not implemented — §10)
export * from './types.js';
export * from './registry.js';
export * from './dose.js';
//# sourceMappingURL=index.js.map